<template>
  <div class="career_teaser">
    <div class="career_teaser__inner container wc-lg">
      <h1 class="f-38 bold uppercase">{{ content.title }}</h1>
      <div class="career_teaser__description" v-html="content.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  computed: {
    content() {
      return _.get(this.contentData, "data.list[0].content.tabs[0]");
    }
  },
  mounted() {
    console.log(this.content);
  }
};
</script>

<style lang="scss" scoped>
.career_teaser__description {
  &::v-deep {
    p,
    span,
    strong,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 18px;
      line-height: 24px;
      font-family: "TBCSailec-Medium";
      @media (max-width: 767px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
}
</style>
